import { getCurrentLanguage } from "../Helpers/RouteHelper";
import { UserService } from "../Services/UserService";
import { createUserRequest } from "../Types/RequestResponse/createUserRequest";

export const useCreateUser = () => {
  const CreateUser = async (formValues: any, selectedSubscription: string, formToken?: { issuedAt: string, signature: string }) => {
    const createUserRequest: createUserRequest = {
      companyName: formValues.companyname,
      firstname: formValues.firstname,
      lastname: formValues.lastname,
      email: formValues.email,
      password: formValues.password,
      subscription: selectedSubscription,
      language: getCurrentLanguage(),
      refCode: formValues.refCode,
      formIssuedAt: formToken?.issuedAt,
      formSignature: formToken?.signature
    }

    return await UserService.CreateUser(createUserRequest);
  };

  return {
    CreateUser
  };
};